<template>
  <div v-loading="pridobivanjeNarocenihEtelefonov">
    <div style="padding-top: 35px">
      <p class="navadno-besedilo">
        Z uporabo storitve eTelefon potekajo klici preko interneta, za vaše sogovornike pa je to običajen telefonski
        klic, ki ga lahko sprejmejo tudi na domačem običajnem telefonu. Storitev lahko uporabljate povsod, tudi v
        tujini, kjer je na voljo brezplačen ali plačljiv dostop do interneta, klic pa se obračunava po ceniku, ki
        velja za klice od doma. Več o storitvi si lahko preberete <a href="" class="primarna-barva">tukaj</a>.
        <br/>
        Storitev eTelefon omogoča opravljanje in sprejemanje telefonskih klicev preko aplikacije na računalniku.
      </p>
    </div>
    <div style="padding-top: 30px" v-if="seznamPodatkov.length > 0">
      <div>
        <p class="open-sans-20pt">
          Naročene eTelefon številke
        </p>
      </div>
      <div v-if="seznamPodatkov.length === 1">
        <div style="padding-top: 20px; padding-bottom: 20px">
          <div v-for="narocenEtelefon in seznamPodatkov">
            <el-form label-width="100px" :label-position="formaOrientacija">
              <el-form-item label="Številka">
                <el-input placeholder="" v-model="narocenEtelefon.stevilka" class="velikost-input" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="Geslo">
                <el-input placeholder="" v-model="narocenEtelefon.geslo" class="velikost-input">
                </el-input>
                <b class="postavitev-sprememba-gesla">
                  <a style="color: black; cursor: pointer"
                     @click="ChangePassword(narocenEtelefon.stevilka, narocenEtelefon.geslo)">
                    Spremeni geslo
                  </a>
                </b>
                <span>
                  <p class="stil-drobni-tisk">
                    Geslo je bilo poslano: {{ narocenEtelefon.datum }}
                    <br/>
                    <b>
                      Pozor:
                    </b> novo geslo mora vsebovati 8 znakov. Uporabite lahko številke ali črke, a brez šumnikov.
                  </p>
                </span>
              </el-form-item>
            </el-form>
            <div style="padding-top: 30px">
              <a class="okvir-odjavi-stevilko vsebina-e-telefon" style="cursor: pointer"
                 @click="DeleteEtelefon(narocenEtelefon.id, narocenEtelefon.geslo)">
                <b>
                  ODJAVI ŠTEVILKO
                </b>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div style="padding-top: 20px" v-if="seznamPodatkov.length > 1">
        <div v-if="prikazTabele === '1'" v-loading="pridobivanjeNarocenihEtelefonov">
          <el-table
              :data="seznamPodatkov"
              :expand-row-keys="expandRowKeys"
              :row-key="row => row.id"
              @expand-change="IzbiraVrsticeZaPrikazPodatkov">
            <el-table-column
                prop="stevilka"
                label="Telefonska številka">
            </el-table-column>
            <el-table-column
                prop="datum"
                label="Datum poslano">
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-top: 30px;">
                  <el-form label-width="100px" :label-position="formaOrientacija">
                    <el-form-item label="Številka">
                      <el-input placeholder="" v-model="scope.row.stevilka" class="velikost-input" :disabled="true">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="Geslo">
                      <el-input placeholder="" v-model="scope.row.geslo" class="velikost-input">
                      </el-input>
                      <b class="postavitev-sprememba-gesla">
                        <a style="color: black; cursor: pointer"
                           @click="ChangePassword(scope.row.stevilka, scope.row.geslo)">
                          Spremeni geslo
                        </a>
                      </b>
                      <span>
                        <p class="stil-drobni-tisk">
                          Geslo je bilo poslano: {{ scope.row.datum }}
                          <br/>
                          <b>
                            Pozor:
                          </b> novo geslo mora vsebovati 8 znakov. Uporabite lahko številke ali črke, a brez šumnikov.
                        </p>
                      </span>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="odmik-odjavi-gumba">
                  <a class="okvir-odjavi-stevilko vsebina-e-telefon" style="cursor: pointer"
                     @click="DeleteEtelefon(scope.row.id, scope.row.geslo)">
                    <b>
                      ODJAVI ŠTEVILKO
                    </b>
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="prikazTabele === '0'" v-loading="pridobivanjeNarocenihEtelefonov">
          <el-table
              :data="seznamPodatkov"
              :expand-row-keys="expandRowKeys"
              :row-key="row => row.id"
              @expand-change="IzbiraVrsticeZaPrikazPodatkov">
            <el-table-column
                prop="stevilka"
                label="Telefonska številka">
            </el-table-column>
            <el-table-column
                prop="datum"
                label="Datum poslano">
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-top: 30px;">
                  <el-form label-width="100px" :label-position="formaOrientacija">
                    <el-form-item label="Številka">
                      <el-input placeholder="" v-model="scope.row.stevilka" class="velikost-input" :disabled="true">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="Geslo">
                      <el-input placeholder="" v-model="scope.row.geslo" class="velikost-input">
                      </el-input>
                      <b class="postavitev-sprememba-gesla">
                        <a style="color: black; cursor: pointer"
                           @click="ChangePassword(scope.row.stevilka, scope.row.geslo)" class="primarna-barva">
                          Spremeni geslo
                        </a>
                      </b>
                      <span>
                        <p class="stil-drobni-tisk">
                          Geslo je bilo poslano:
                          <br/>
                          <b>
                            Pozor:
                          </b> novo geslo mora vsebovati 8 znakov. Uporabite lahko številke ali črke, a brez šumnikov.
                        </p>
                      </span>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="odmik-odjavi-gumba">
                  <a class="okvir-odjavi-stevilko vsebina-e-telefon" style="cursor: pointer"
                     @click="DeleteEtelefon(scope.row.id, scope.row.geslo)">
                    <b>
                      ODJAVI ŠTEVILKO
                    </b>
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="dolzinaSeznamaNaroceniEtelefoni > 4" style="padding-bottom: 20px">
          <div class="text-center" style="cursor: pointer;">
            <el-pagination
                :hide-on-single-page="true"
                @current-change="PrikaziStran"
                :page-size="4"
                layout="prev, pager, next"
                :total="dolzinaSeznamaNaroceniEtelefoni"
                small>
            </el-pagination>
          </div>
        </div>
      </div>
      <div style="padding-top: 10px;">
        <hr class="hr-stil">
      </div>
    </div>
    <div style="padding-top: 25px">
      <div>
        <p class="open-sans-20pt">
          Naročilo številke za eTelefon
        </p>
      </div>
      <div v-if="seznamMoznihTelStevilk.length > 0">
        <div style="padding-top: 20px">
          <el-form label-width="120px" :label-position="formaOrientacija">
            <el-form-item label="Izbira številke">
              <el-select v-model="narociloNoveStevilke"
                         placeholder="Izberite tel. številko" class="velikost-input">
                <el-option v-for="(data, key) in seznamMoznihTelStevilk"
                           :value="data"
                           :label="VrniFormatiranoTelefonsko(String(data), 5)"
                           :key="key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="padding-top: 20px">
          <el-checkbox v-model="objavaStevilkeVimeniku">
          </el-checkbox>
          Objava številke v imeniku
        </div>
        <div style="padding-top: 10px">
          <el-checkbox v-model="prejetjeKljucaSms">
          </el-checkbox>
          Ključ želim prejeti preko sms-a <b> {{ VrniFormatiranoTelefonsko(gsmOdStranke, '5') }}</b>
        </div>
        <div style="padding-top: 30px">
          <el-button type="primary" class="gumb-potrdi" @click="CreateEtelefon">
            NAROČI ŠTEVILKO
          </el-button>
        </div>
      </div>
      <div v-else>
        <div style="padding-top: 40px">
          Žal nimate možnosti naročitve nove številke.
        </div>
      </div>
    </div>
    <div style="padding-top: 30px; padding-bottom: 30px">
      <hr class="hr-stil">
    </div>
    <div>
      <div>
        <ul>
          <li>
            <img src="/static/img/Naroci/NarociTelefonija/Icon-material-get-app.png">
            <span class="open-sans-20pt">
                Prenos aplikacije za eTelefon
            </span>
          </li>
        </ul>
      </div>
      <div style="padding-top: 20px">
        <p class="navadno-besedilo">
          Za delovanje potrebujete SIP telefonsko številko in aplikacijo, ki jo lahko brezplačno dobite
          na spodnji povezavi.
        </p>
      </div>
      <div style="padding-top: 30px">
        <a class="okvir-prenos-aplikacije vsebina-e-telefon" style="cursor: pointer"
           href="https://horizont.t-2.net/documents/T-2_e-Telefon.exe">
          <b>
            PRENOS APLIKACIJE
          </b>
        </a>
      </div>
    </div>
    <div style="padding-top: 30px; padding-bottom: 30px">
      <hr class="hr-stil">
    </div>
    <div>
      <div class="postavitev-tabele">
        <p class="open-sans-20pt">
          Cenik spremembe storitev telefonija
        </p>
        <div v-show="prikazTabele === '1'">
          <el-table :data="cenikSPremembeStoritevTelefonija">
            <el-table-column label="Storitev" prop="naziv" empty-text="Ni podatkov">
            </el-table-column>
            <el-table-column label="Cena z DDV" style="float: right" width="100px">
              <template slot-scope="scope">
                {{ scope.row.cenaSI }} €
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="prikazTabele === '0'">
          <el-table :data="cenikSPremembeStoritevTelefonija"
                    :expand-row-keys="expandRowKeys"
                    :row-key="row => row.naziv"
                    empty-text="Ni podatkov"
                    @expand-change="IzbiraVrsticeZaPrikazCenika">
            <el-table-column prop="naziv" label="Storitev">
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding-top: 20px; padding-bottom: 20px">
                  <p>
                    Storitev: {{ props.row.naziv }}
                    <br/>
                    Cena z DDV: {{ props.row.cenaSI }} €
                  </p>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Checkbox,
  Input,
  Button,
  Form,
  FormItem,
  Select,
  Option,
  Collapse,
  CollapseItem,
  Pagination,
  MessageBox
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'

export default {
  name: 'eTelefon',
  mixins: [PrikazVsebine, StringConverter, FormatirajTelefonskoStevilko],
  data () {
    return {
      formaOrientacija: 'left',
      mejnaSirina: 1000,
      objavaStevilkeVimeniku: false,
      prejetjeKljucaSms: false,
      seznamNarocenihTelefonov: [],
      expandRowKeys: [],
      seznamMoznihTelStevilk: [],
      narociloNoveStevilke: '',
      seznamPodatkov: [],
      pridobivanjeNarocenihEtelefonov: false,
      dolzinaSeznama: null,
      prikazTabele: '1',
      mejnaSirinaTabela: 1340,
      dolzinaSeznamaNaroceniEtelefoni: null
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Pagination.name]: Pagination
  },
  props: {
    izbranPrikljucek: String,
    cenikSPremembeStoritevTelefonija: Array,
    gsmOdStranke: String
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetNarocenihEtelefonov()
        this.GetNaborTelefonskihStevilk()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetNarocenihEtelefonov()
    this.GetNaborTelefonskihStevilk()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    IzbiraVrsticeZaPrikazCenika (row) {
      const id = row.naziv
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    IzbiraVrsticeZaPrikazPodatkov (row) {
      const id = row.id
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    GetNarocenihEtelefonov () {
      this.pridobivanjeNarocenihEtelefonov = true
      this.seznamPodatkov = []
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/telefonija/etelefon/seznam?',
        param,
        null,
        'SetNarocenihEtelefonov',
        'ErrNarocenihEtelefonov')
    },
    SetNarocenihEtelefonov (podatki) {
      this.seznamNarocenihTelefonov = podatki.data
      if (typeof this.seznamNarocenihTelefonov !== 'undefined') {
        let tmpArray = []
        this.dolzinaSeznamaNaroceniEtelefoni = this.seznamNarocenihTelefonov.length
        const chunk = 4
        for (let i = 0; i < this.dolzinaSeznamaNaroceniEtelefoni; i += chunk) {
          tmpArray.push(this.seznamNarocenihTelefonov.slice(i, i + chunk))
        }
        this.seznamNarocenihTelefonov = tmpArray
        this.PrikaziStran(1)
      }
    },
    PrikaziStran (stran) {
      if (typeof this.seznamNarocenihTelefonov[stran - 1] !== 'undefined') {
        this.seznamPodatkov = this.seznamNarocenihTelefonov[stran - 1]
      } else {
        this.seznamPodatkov = []
      }
      this.pridobivanjeNarocenihEtelefonov = false
    },
    ErrNarocenihEtelefonov (podatki) {
      this.pridobivanjeNarocenihEtelefonov = false
    },
    GetNaborTelefonskihStevilk () {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/telefonija/etelefon/mozneStevilke',
        param,
        null,
        'SetNaborTelefonskihStevilk',
        'ErrNaborTelefonskihStevilk')
    },
    SetNaborTelefonskihStevilk (podatki) {
      this.seznamMoznihTelStevilk = []
      this.seznamMoznihTelStevilk = podatki.data
      this.narociloNoveStevilke = podatki.data[0]
    },
    ErrNaborTelefonskihStevilk (podatki) {
    },
    CreateEtelefon () {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('stevilka=' + this.narociloNoveStevilke)
      param.push('imenikObjava=' + this.objavaStevilkeVimeniku)
      param.push('sendSms=' + this.prejetjeKljucaSms)
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/telefonija/etelefon/kreiraj?',
        param,
        null,
        'SetCreateEtelefon',
        'ErrCreateEtelefon')
    },
    SetCreateEtelefon () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno kreiran eTelefon.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetNarocenihEtelefonov()
      this.GetNaborTelefonskihStevilk()
      this.objavaStevilkeVimeniku = false
      this.prejetjeKljucaSms = false
    },
    ErrCreateEtelefon (podatki) {
      this.ShowWarningMessage(podatki)
    },
    DeleteEtelefon (id, geslo) {
      MessageBox.confirm(
        'Ali ste prepričani, da želite odjaviti številko?', {
          customClass: 'opozorilo-dialog',
          cancelButtonClass: 'gumb-preklici',
          confirmButtonClass: 'gumb-potrdi',
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči'
        }).then(() => {
        this.pridobivanjeNarocenihEtelefonov = true
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('id=' + id)
        param.push('geslo=' + geslo)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/etelefon/odstrani?',
          param,
          null,
          'SetDeleteEtelefon',
          'ErrDeleteEtelefon')
      }).catch((err) => {
        err = null
      })
    },
    SetDeleteEtelefon () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno odstranjen eTelefon.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetNarocenihEtelefonov()
      this.GetNaborTelefonskihStevilk()
    },
    ErrDeleteEtelefon (podatki) {
      this.ShowWarningMessage(podatki)
    },
    ChangePassword (telefonskaStevilka, geslo) {
      MessageBox.confirm(
        'Ali ste prepričani, da želite spremeniti geslo?', 'Opozorilo', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          type: 'warning'
        }).then(() => {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('telefonskaStevilka=' + telefonskaStevilka)
        param.push('geslo=' + geslo)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/etelefon/spremeniGeslo?',
          param,
          null,
          'SetChangePassword',
          'ErrChangePassword')
      }).catch((err) => {
        err = null
      })
    },
    SetChangePassword () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno spremenjeno geslo.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrChangePassword (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelefonija/Etelefon.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelefonija/eTelefon.vue